import React from 'react';
import './UserProfileCard.css';
import Avatar from '../widgets/Avatar';
import {Link} from 'react-router-dom';
import OptionsButton from '../widgets/OptionsButton';

const UserCardCouponRedeem = ({profile, options, children}) => {
	return (
		<li className="UserProfileCard">
			<Link to={`/@${profile.profile.uniqueName}`} target="_blank" rel="noopener noreferrer">
				{options && <OptionsButton className="ProfileCard-options" options={options} />}
				<Avatar provider={profile} size={48} />
				<div className="UserProfileCard-detail">
					<div className="UserProfileCard-name">
						{profile.user.firstname} {profile.user.lastname}
					</div>
					<div className="UserProfileCard-location">
						<span className="icon-room" />
						<span>{profile.user.location.suburb}</span>
					</div>
				</div>
			</Link>
			{children}
		</li>
	);
};

export default UserCardCouponRedeem;



// WEBPACK FOOTER //
// ./src/profile/UserCardCouponRedeem.js